import { getUserInfo } from 'utils/functions/getUserInfo';
import { themeApis } from '../apis';

export const getThemeProductService = async ({ commandId }: { commandId: string }) => {
  const { lastCache } = getUserInfo();
  const response = await themeApis.vedaApplication.userApi.theme.getProduct({ commandId, cacheVersion: lastCache });
  return response;
};
